import React, {
  Component
} from 'react';
import {
  Link
} from 'react-router';
import {
  connect
} from 'react-redux';
import {
  bindActionCreators
} from 'redux';
import {
  changeColor,
  clearDraw
} from '../../actions/ts_overlay_actions.js';
import {updateModal} from '../../actions/modal.js';
import {Button, Modal, Grid,Row,Col,Clearfix, ButtonToolbar, DropdownButton, MenuItem, ButtonGroup,Dropdown} from 'react-bootstrap';
import {
  CirclePicker
} from 'react-color';
import Draggable from 'react-draggable';
//import HTML2Canvas from 'html2canvas';
import ReactDOM from 'react-dom';
import {getGameTitle, getMapTitle} from '../../utils/maps/titleUtil.js';
var Colors = React.createClass({


  changeColor(color) {
    var {dispatch,overlay} = this.props;
    dispatch(changeColor(color,overlay.color1,overlay.color2));
  },

  render() {
    var {overlay,map,currentUser,canvas} = this.props;
    var colorStyle;

    var circle1Style =  <div className='divColor1Circle'/>
    var circle2Style = <div className='divColor2Circle'/>
    var circle3Style = <div className='divColorWhiteCircle'/>

    if (overlay.color == overlay.color1) {
      circle1Style = <div className='divColor1CircleBorder'/>
      colorStyle = circle1Style;
    }
    if (overlay.color == overlay.color2) {
      circle2Style = <div className='divColor2CircleBorder'/>
      colorStyle = circle2Style;
    }
    if (overlay.color == 'white') {
      circle3Style = <div className='divColorWhiteCircleBorder'/>
      colorStyle = circle3Style;
    }

      var pencilIcon = <i className="fa fa-pencil fa-lg"></i>


    return (
      <span>
    {/*}  <ButtonGroup bsStyle={false}  className="navbar-brand">
      <DropdownButton noCaret={true} pullRight={false} bsStyle={false} className="divDisplayName" title={pencilIcon}>
        <Clearfix>*/}
        <Link className="navbar-brand" onClick={(event) => {
          this.changeColor(overlay.color1);
        }}>
          <span>
            {circle1Style}
          </span>
        </Link>
        <Link className="navbar-brand" onClick={(event) => {
          this.changeColor(overlay.color2);
        }} >
          <span>
              {circle2Style}
          </span>
        </Link>
        <Link className="navbar-brand" onClick={(event) => {
         this.changeColor('white');
       }} >
         <span>
          {circle3Style}
         </span>
        </Link>
    {/* </Clearfix>
      </DropdownButton>
    </ButtonGroup>*/}
  </span>

    );
  }
});


module.exports = connect((state) => {
  return {
    overlay: state.overlay, map: state.map, currentUser: state.currentUser, canvas:state.canvas
  }
})(Colors);



// WEBPACK FOOTER //
// ./src/app/components/tools/colors.js